<template>
  <div class="container">
    <div class="header">
      <span class="preview_font">预览</span>
      <span class="close_icon" @click="close">×</span>
    </div>
      <div class="img_box">
        <img :src="require(`@/assets/fileExample/${imgName}.jpg`)" alt="">
      </div>
  </div>
</template>

<script>
import PDFJS from 'pdfjs-dist'
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;
export default {
  data () {
    return {
      pdfObject: {numPages: 0},
      currPage: 1,
      loadPage: 0,
      scale: 2,
      handoutUrl: '',
      showFlag: false
    }
  },
  props: {
    imgName: {
      type: String,
      default: ''
    }
  },
  methods: {
    close:function() {
      this.$emit('close',false)
    }
  }
}
</script>
<style scoped>

</style>
<style lang='less' scoped>

.container{
  background: white;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  position: fixed;
  overflow: auto;
  top: 0;
  left: 0;
  z-index: 1000;
}
.header{
  display: flex;
  width: 100%;
  background: #1E88E5;
  height: 100px;
  color: white;
  position: fixed;
  top: 0;
  justify-content: space-between;
  align-items: center;
}
.header .preview_font{
  font-size: 34px;
  margin-left: 50px;
}
.header .close_icon{
  font-size: 50px;
  margin-right: 50px;
}
.pdf_canvas{
  padding-top: 100px;
  overflow: auto;
  -webkit-overflow-scrolling: touch !important;
  display: flex;
  flex-direction: column;
}
canvas{
  min-width: 70%;
  max-width: 100%;
  /* margin-bottom: 1px; */
}
.pages_box{
  position: fixed;
  top: 18px;
}
.page_span{
  display: inline-block;
  height: 28px;
  line-height: 28px;
  background-color: rgba(0,0,0,0.5);
  padding: 0 8px;
  margin-right: 10px;
  color: white;
  border-radius: 5px;
}
.img_box{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  padding: 20px;
  padding-top: 100px;
  box-sizing: border-box;
  img{
    margin-top: 10px;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
